/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Days
 * 
 * 1 = Weeks
 * 
 * 2 = Months
 */
export enum LeadTimeType {
  Days = 0,
  Weeks = 1,
  Months = 2
}
